import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {QuoteCommentNotificationDataApiDto} from "../../../api/model/rest";

/**
 * Quote comment notification class data.
 */
export default class QuoteCommentNotificationData {
	/**
	 * @param leadId
	 * @param leadReferenceNumber
	 * @param entity
	 * @param quoteId
	 * @param contactId
	 * @param commentId
	 * @param commentText
	 */
	constructor(readonly leadId: string,
		readonly leadReferenceNumber: string,
		readonly entity: AuthenticatedEntity,
		readonly quoteId: string,
		readonly contactId: string,
		readonly commentId: string,
		readonly commentText: string) {}

	static fromJson(json: QuoteCommentNotificationDataApiDto): QuoteCommentNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new QuoteCommentNotificationData(
			json.leadId,
			json.leadReferenceNumber,
			creator,
			json.quoteId,
			json.contactId,
			json.commentId,
			json.commentText)
	}
}
